import Layout from "../components/Layout";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import EmpAssessmentCard from "../components/EmpAssessmentCard";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import EmpInfoCard from "../components/EmpInfoCard";
import './SupervisorAssessmentPage.css';

const SupervisorRemarksForTaskList = () => {
    const primeToast = useRef(null)
    const { user } = useSelector(state => state['auth']);
    const [optionList, setOptionList] = useState([]);
    const [quater, setQuater] = useState([])
    const [assessmentIndicator, setAssessmentIndicator] = useState({ isLoading: false, list: [] })
    const [employees, setEmployees] = useState([])
    const [employeeAssessment, setEmployeeAssessment] = useState([])
    const [supervisorAssessment, setSupervisorAssessment] = useState([]);
    const [supervisorUpdateCount, setSupervisorUpdateCount] = useState([])
    const [isAssessmentLoading, setIsAssessmentLoading] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [taskList, setTaskList] = useState([]);

    useEffect(() => {
        loadAllEmployees();
        getAssesstmentOpinionList();
    }, [])

    const loadAllEmployees = () => {
        axios.get(BASE_URL + "/api/employeetasklist/GetEmployeeListForSupervisor/" + user.registerID)
            .then(response => {
                setEmployees(response.data)
                console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getAssesstmentOpinionList = () => {
        axios.get(BASE_URL + "/api/employeetasklist/GetAllComments")
            .then(response => {
                setOptionList(response.data)
                console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const onEmployeeSelect = (e) => {
        const registerId = e.currentTarget.value;
        getTaskList(registerId, user.quarterID);
        getEmployeeAssessment(registerId)
        getAssesstmentOpinionList();
    }

    const getTaskList = async (id, quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        await axios.post(BASE_URL + "/api/employeetasklist/GetEmployeeTaskList", JSON.stringify(data))
            .then(response => {
                setTableData(response.data);
                setIsLoading(false);
                //console.log(response.data);
            })
            .catch(function (error) {
                setTaskList(false);
                console.log(error);
            });
    }

    const getEmployeeAssessment = (id) => {
        setIsAssessmentLoading(true)
        axios.get(BASE_URL + "/api/employeetasklist/SupervisorSelectedEmployeeForTask/" + id)
            .then(response => {
                console.log(response.data);
                setIsAssessmentLoading(false)
                setEmployeeAssessment(response.data)
                updateSupervisorAssessment(response.data)
            })
            .catch(e => {
                setIsAssessmentLoading(false)
                console.log(e)
            })
    }

    const updateSupervisorAssessment = (list) => {
        if (list.length !== 0) {
            const funckingAssessment = []
            list.map(item => {
                if (item.userAssestmentOpinionID !== null) {
                    funckingAssessment.push({
                        opinionID: item.userAssestmentOpinionID,
                        assesmentInformationID: item.assesmentInformationID,
                        registerID: user.registerID
                    })
                }

            });
            setSupervisorAssessment(funckingAssessment)
            //set state
        }
    }

    const onDataSave = async (sl, registerId) => {
        //const params = { SL: sl, registerID: registerId, SupervisedBy: user.registerID };

        const unsetOpinion = tableData.filter((item) => Number(item.sl) === sl)

        const data = {
            SL: unsetOpinion[0].sl,
            SupervisedBy: unsetOpinion[0].supervisedBy.toString(),
            SupervisorComment: unsetOpinion[0].supervisorComment
        }
        console.log(JSON.stringify(data));
        await axios.post(BASE_URL + "/api/employeetasklist/SaveSupervisorComments", JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    console.log("Save success!!");
                    primeToast.current.show({
                        severity: "success",
                        summary: "success",
                        detail: "Task Saved Successfully",
                        life: 3000,
                    });
                    getTaskList(registerId, user.quarterID);
                }
            });
    };

    const onCommentChange = (sl, e) => {
        const comments = e.currentTarget.value;
        //const unsetOpinion = tableData.filter(item => Number(item.sl) === sl)
        tableData.forEach(taskList => {
            if (taskList.sl === sl) {
                taskList.supervisorComment = comments;
                taskList.supervisedBy = user.registerID;
            }
        });
        //console.log(tableData);
    }

    function Table({ tableData }) {
        return (
            <table className="table" rows={10} paginator>
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                        <th hidden={true}>ID</th>
                        <th className="text-center">Action</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                                <td hidden={true}>{data.sl}</td>
                                <td className="text-center">

                                    <select className="form-select"
                                        defaultValue={data.supervisorComment}
                                        onChange={(e) => onCommentChange(data.sl, e)}
                                        aria-label=".form-select-sm example">
                                        <option value={-1}>Select Opinion</option>
                                        {optionList.map((value, index) => <option key={index}
                                            value={value.commentID}>{value.commentName}</option>)}
                                    </select>

                                </td>
                                <td className="text-center">
                                    <input
                                        type="submit"
                                        onClick={() => onDataSave(data.sl, data.registerID)}
                                        className="btn btn-danger"
                                        value="Save" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <Layout>
            <Toast ref={primeToast} />
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-6">
                            <select id="ddlEmployee" name="ddlEmployee" className="form-select" onChange={onEmployeeSelect}
                                aria-label=".form-select-sm example">
                                <option value={-1}>{"Select Employee"}</option>
                                {employees.map((value, index) => <option key={index}
                                    value={value.registerID}>{value.employeeName}</option>)}
                            </select>
                        </div>

                        <div className="col-md-6" style={{ textAlign: 'right', fontSize: '.85rem' }}>
                            <b>Quarter:</b> {user.quarterName}/{new Date().getFullYear()}
                        </div>

                    </div>
                </div>
                <div className="card-body">
                    {employeeAssessment.length !== 0 ?
                        <EmpInfoCard empName={employeeAssessment[0].employeeName}
                            department={employeeAssessment[0].department}
                            designation={employeeAssessment[0].designation}
                            email={employeeAssessment[0].email} />
                        : (<div className="p-5"><h3>Supervisor <b>Task </b> Assestment Area(Please Select Employee)</h3></div>)}
                    {isAssessmentLoading ? <ProgressSpinner style={{ width: 20, height: 20 }} /> : ""}
                    {employeeAssessment.length !== 0 ? <div className="row">
                        {employeeAssessment.map((value, index) => <div key={index} className="col-md-4">

                        </div>)}

                    </div> : <div></div>}

                    <Table tableData={tableData} />

                </div>
            </div>
        </Layout>
    )

}


export default SupervisorRemarksForTaskList